import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query'

const queryClient = new QueryClient({
    queryCache: new QueryCache({
        onError: (error: any) => {
            return null;
        },
    }),
    mutationCache: new MutationCache({
        onError: (error: any) => {
            return null;
        },
    }),
});

export default queryClient

/**
 * Model for general query in Restful API
 */

export type IQueryParams = {
    query?: string;
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    [propName: string]: any;
};
